import BaseRoute from "utils/base_route";

import LlmRunCompareContainer from "./containers/llm_run_compare";

export default class LlmRunCompareRoute extends BaseRoute {
  constructor(store) {
    super("compare", store);
  }

  getChildRoutes(state, cb) {
    cb(null, []);
  }
  getComponents(location, cb) {
    cb(null, LlmRunCompareContainer);
  }
}
